const  state = {
        visitedViews:[],//快捷导航栏
    };
    const mutations = {
      //添加方法
      ADD_VISITED_VIEWS:(state:any,view:any) => {
          //如果添加的是在数组里面，就不添加
        if(state.visitedViews.some( (i:any) => i.fullPath === view.fullPath)) return;
          state.visitedViews.push(Object.assign({},view,{
               title:view.meta.title || 'no-name'
            })
          )
      },
      //删除方法
      DEL_VISITED_VIEWS:(state:any,view:any) => {
        state.visitedViews.forEach((e:any,i:number) => {
            if(e.fullPath === view.fullPath){
              state.visitedViews.splice(i,1)
            }
          });
      } 
    };
    const  actions = {
      addVisitedViews({commit}:any,view:any){
        commit('ADD_VISITED_VIEWS',view)
      },
      delVisiteViews({commit,state}:any,view:any){
        return new Promise((resolve)=>{
        commit('DEL_VISITED_VIEWS',view)
        resolve([...state.visitedViews])
        })
      }
    }


export default {
  state,
  mutations,
  actions
}